(function ($, Drupal) {
    Drupal.behaviors.breadcrumbs = {
        attach: function (context, settings) {
            $("#block-breadcrumbs ol").map(function (idx, breadcrumb) {
                let $breadcrumb = $(breadcrumb);

                if ($breadcrumb.children().length >= 4) {
                    let detached_children = $breadcrumb.children().slice(1, -2).detach();

                    let expand_breadcrumb = $('<li><a href="" title="Show all breadcrumbs">...</a></li>');

                    expand_breadcrumb.click(function (event) {
                        event.preventDefault();
                        $breadcrumb.children().slice(1, -2).remove();
                        $breadcrumb.children().first().after(detached_children);
                    });

                    $breadcrumb.children().first().after(expand_breadcrumb);
                }
            });
        }
    };
}(jQuery, Drupal));
